import { render, staticRenderFns } from "./topBtn.vue?vue&type=template&id=876d617e"
import script from "./topBtn.vue?vue&type=script&lang=js"
export * from "./topBtn.vue?vue&type=script&lang=js"
import style0 from "./topBtn.vue?vue&type=style&index=0&id=876d617e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports